var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"row align-center"},[_c('div',{staticClass:"columns small-12"},[_vm._v("\n      "+_vm._s(_vm.msg)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }